import { RefreshResult } from "@idw-types/common";

export enum AxnCacheActionTypes {
    SET_AXN_CACHE_REFRESHING = "SET_AXN_CACHE_REFRESHING",
    SET_AXN_CACHE_REFRESH_RESULTS = "SET_AXN_CACHE_REFRESH_RESULTS"
}

type SetAxnCacheRefreshingAction = {
    type: AxnCacheActionTypes.SET_AXN_CACHE_REFRESHING,
    payload: { isRefreshing: boolean; }
};

export const setAxnCacheRefreshing = (isRefreshing: boolean): SetAxnCacheRefreshingAction => ({
    type: AxnCacheActionTypes.SET_AXN_CACHE_REFRESHING,
    payload: { isRefreshing }
});

type SetAxnCacheRefreshResultAction = {
    type: AxnCacheActionTypes.SET_AXN_CACHE_REFRESH_RESULTS,
    payload: { refreshResults: Array<RefreshResult>; lastRefreshDate: Date; }
}

export const setAxnCacheRefreshResults = (refreshResults: Array<RefreshResult>, lastRefreshDate: Date): SetAxnCacheRefreshResultAction => ({
    type: AxnCacheActionTypes.SET_AXN_CACHE_REFRESH_RESULTS,
    payload: { refreshResults, lastRefreshDate }
});


export type AxnCacheActions =
    SetAxnCacheRefreshingAction |
    SetAxnCacheRefreshResultAction